/* eslint-disable @typescript-eslint/no-unused-vars */
import React from "react";
import styled, { css } from 'styled-components';
import { themeToken } from "../../utils/cpds-utils";

/* Note: By default, this component is rendered as a 'div' element. 
If your use case requires a different HTML element, please update the component accordingly. */
const CpdsHrStyleTag = styled.hr`
    ${({ theme: { styles: { cpds } }, ...props }) => {
        const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);
       
        return css`
            position:absolute;
            left:${token?.separator_position_left || '50%'};
            top:${token?.separator_position_top || '0'};
            width:${token?.separator_width || '50%'};
            height: ${token?.separator_height || '4px'};
            border-width: ${token?.separator_border_width || '0px'};
            color: ${token?.separator_primary_color || 'black'};
            transform:translateX(${(props) => props?.horizontal ? '-50%' : '0'});
            background-color: ${token?.separator_primary_background_color || 'gray'};
            margin:0px;
            /* End styles for button here */

            /* Styles overrides */
            ${(props) => props?.styleOverrides || ''}
        `}
    }
`;

const CpdshrWrapperStyleTag = styled.div`
${({ theme: { styles : {cpds} } }) => css`
    width:100%;
    position:relative;
    height: ${(props) => props?.divHight || '4px'};
   
`}
`

export { CpdsHrStyleTag, CpdshrWrapperStyleTag };


// ${horizantal ?  '' : 'transform:translateX(-50%)'}